"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function MenuTable() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "PrivacyPolicy-container-columnLeft-title"
  }, "Central de Privacidade"), /*#__PURE__*/_react["default"].createElement("table", {
    className: "PrivacyPolicy-container-columnLeft-table"
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    className: "PrivacyPolicy-container-columnLeft-table-title"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#introducao"
  }, "Introdu\xE7\xE3o e defini\xE7\xF5es")))), /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#informacoes-gerais"
  }, "1 - Informa\xE7\xF5es gerais"))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#direitos-do-usuario"
  }, "2 - Direitos do usu\xE1rio"))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#informacoes-coletadas"
  }, "3 - Informa\xE7\xF5es coletadas"))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#tratamento-de-dados"
  }, "4 - Tratamento de dados"))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#alteracoes-na-politica"
  }, "5 - Altera\xE7\xF5es na P.P"))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#armazenamento-de-dados"
  }, "6 - Armazenamento de dados"))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#direito-aplicavel"
  }, "7 - Direito aplic\xE1vel e foro"))))));
}
var _default = MenuTable;
exports["default"] = _default;